s<template>
  <div id="bioNews" v-if="data" class="container">
    <div class="b1">
      <div style="width:210px;margin:0 auto;display:block">
        <div class="clear">
          <div class="clear-item" style="padding-right:5px;color:#15DCA2">
            <i class="far fa-newspaper fa-4x"></i>
          </div>
          <div class="clear-item">
            <div class="lv1Text" style="font-size:23px;margin-bottom:5px">Bioflin News</div>
            <div class="lv2Text">您的作品，我们来发表</div>
          </div>
        </div>
      </div>
      <span style="float:right;margin-top:-39px;margin-right:30px;">
        <router-link to="/user/myNews/2/7">
          <el-button round size="small">发布文章</el-button>
        </router-link>
      </span>
    </div>
    <div v-if="loading" style="padding:50px 0;">
      <clip-loader color="#e2211c"></clip-loader>
    </div>
    <div v-if="!loading">
      <el-row style="margin-bottom:20px" :gutter="20">
        <el-col :span="8" v-for="(item,index) of data" :key="index">
          <div class="lv3Text item">
            <div class="cover">
              <router-link :to="'/viewNews?id='+item.id">
                <el-image style="width: 347px; height: 250px" :src="serve +item.cover" fit="cover"></el-image>
              </router-link>
            </div>
            <div class="lv3Text t1">
              <el-row :gutter="10">
                <el-col :span="6" align="right">
                  <div class="lv1Text right_weiter">{{item.writer}}</div>
                </el-col>
                <el-col :span="18">
                  <router-link :to="'/viewNews?id='+item.id">
                    <div class="lv2Text tt">
                      {{_.truncate(item.abstract, {
                      'length': 18
                      })
                      }}
                    </div>
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="t2 lv3Text">
            <el-row>
              <el-col :span="8">
                <div align="center">
                  <i class="far fa-comment-dots"></i>
                  {{item.comment_number}}
                </div>
              </el-col>
              <el-col :span="8">
                <div
                  align="center"
                  class="lv0Text"
                  v-if="item.is_collect&&item.is_collect==1"
                  @click="del_collect(item.id)"
                >
                  <i class="fas fa-heart"></i>
                  {{item.collect}}
                </div>
                <div align="center" v-else @click="add_collect(item.id)">
                  <i class="fas fa-heart"></i>
                  {{item.collect}}
                </div>
              </el-col>
              <el-col :span="8">
                <div
                  align="center"
                  class="lv0Text"
                  v-if="item.is_like&&item.is_like==1"
                  @click="del_like(item.id)"
                >
                  <i class="fas fa-thumbs-up"></i>
                  {{item.like}}
                </div>
                <div align="center" v-else @click="add_like(item.id)">
                  <i class="fas fa-thumbs-up"></i>
                  {{item.like}}
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div class="pager" align="center">
        <el-pagination
        hide-on-single-page
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="12"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  components: {
    ClipLoader
  },
  data() {
    return {
      //
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      total: 0,
      data: {},
      loading: true
    };
  },
  watch: {},
  activated() {
    this.$store.commit("set_top_nav", "5");
  },
  created() {
    //
    this.$store.state.user_location = "Bioflin News";
    this.initData();
  },
  methods: {
    //
    del_like(id) {
      this.axios
        .get(this.serve + "/collect/cancel_like_bioflinnews", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.load();
          }
        });
    },
    add_like(id) {
      this.axios
        .get(this.serve + "/collect/like_bioflinnews", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.load();
          }
        });
    },
    del_collect(id) {
      this.axios
        .get(this.serve + "/collect/cancel_bioflinnews", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.load();
          }
        });
    },
    add_collect(id) {
      this.axios
        .get(this.serve + "/collect/collect_bioflinnews", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.load();
          }
        });
    },
    pageChange(v) {
      this.page = v;
      this.load();
    },
    load() {
      this.axios
        .get(this.serve + "/bioflinnews_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/bioflinnews_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.loading = false;
          this.data = res.data.data.results;
          this.total = res.data.data.total;
        });
    }
  }
};
</script>
<style lang="scss">
#bioNews {
  padding-top: 30px;
  .tt:hover {
    text-decoration: underline;
  }
  .b1 {
    background-color: #eaedf1;
    border: 1px solid #ddd;
    padding: 20px 0;
    width: 100%;
    margin-bottom: 20px;
  }
  .item {
    background-color: #fff;
    padding: 20px 20px 10px 20px;
    .right_weiter {
      width: 50px;
      height: 16px;
      margin: 0 auto;
      overflow: hidden;
    }
  }
  .cover {
    margin-bottom: 10px;
  }
  .t2 {
    border-top: 1px solid #ddd;
    margin-bottom: 20px;
    padding: 10px 20px;
    background-color: #fff;
  }
  .pager {
    background-color: transparent;
  }
  .fa-w-16 {
    cursor: pointer;
  }
}
</style>